<template>
  <div>
    <div ref="widgetContainer">
      <Row class="widget-container">
        <i-col :lg="24" :md="24" :sm="24" :xs="24">
          <Forms></Forms>
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Forms from './forms'

  export default {
    name: 'MyLeadForms',
    components: {
      Forms
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['getDates', 'getEventId']),
    },
    watch: {},
    methods: {
      triggerExportPdf() {
        this.$emit('exportPdf', this.$refs.widgetContainer, 'testPDF.pdf')
      },
      getAllData(id) {
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b_MyLeadForms/MyLeadForms.vue